export default function getConfig({
  idList,
  idField,
  searchField,
  searchAttributesArray,
  noSearch,
  baseQueryParams,
  baseAndQueryParams,
  useEntities,
  truncateEntities,
  entities,
  navFullIdField,
}) {
  const andQueryParams = [];
  const entitiesQueryParams =
    useEntities &&
    entities.map((ent) => {
      return {
        [navFullIdField]: {
          $like: `${
            truncateEntities
              ? ent.nav_full_id.slice(0, truncateEntities)
              : ent.nav_full_id
          }%`,
        },
      };
    });
  if (entitiesQueryParams && entitiesQueryParams.length) {
    andQueryParams.push({ $or: entitiesQueryParams });
  }

  const orQueryParams = [];
  const search = searchField
    ? searchAttributesArray.map((attr) => {
        return {
          [attr]: { $instr: searchField },
        };
      })
    : searchAttributesArray.map((attr) => {
        return {
          [attr]: { $like: '%' },
        };
      });
  if (search && !noSearch && search.length) {
    orQueryParams.push({ $or: search });
  }

  const chosenIds =
    idList &&
    idList.length &&
    idList.map((id) => {
      return {
        [idField]: { $eq: id },
      };
    });
  if (chosenIds && chosenIds.length) {
    orQueryParams.push({ $or: chosenIds });
  }

  if (orQueryParams.length) {
    andQueryParams.push({ $or: orQueryParams });
  }

  if (andQueryParams.length) {
    return {
      ...baseQueryParams,
      q: {
        $and: [...baseAndQueryParams, ...andQueryParams],
      },
    };
  }
  if (baseAndQueryParams.length) {
    return {
      ...baseQueryParams,
      q: {
        $and: baseAndQueryParams,
      },
    };
  }
  return baseQueryParams;
}
